import React from "react";
import Profiles from "../../helper/Profiles";
import SocialConnect from "../../helper/SocialConnect";
import Span from "../../helper/Span";
import style from "../../sass/home.module.scss";
import Resume from "../../helper/resume/Richhapal.pdf";
import { useNavigate } from "react-router-dom";

const Home = () => {
     const navigate = useNavigate();
     const handleNavigate = () => {
          navigate("./skill");
     };

     const openPDFInNewWindow = () => {
          window.open(Resume);
     };
     return (
          <section className={style.home}>
               <div className={style.container}>
                    <div className={style.myinfo}>
                         <div className={style.myinfo_text}>
                              {/* object introduction declaration */}
                              <div className={style.myinfo_text_object_declaration}>
                                   <div className={style.myinfo_text_object_declaration_const}>
                                        {"const-".split("").map((alphabet, index) => (
                                             <Span alp={alphabet} key={index} />
                                        ))}
                                   </div>
                                   <div className={style.myinfo_text_object_declaration_intro}>
                                        {"Introduction-".split("").map((alphabet, index) => (
                                             <Span alp={alphabet} key={index} />
                                        ))}
                                   </div>
                                   =
                                   <div className={style.myinfo_text_object_declaration_curly}>
                                        {"-{".split("").map((alphabet, index) => (
                                             <Span alp={alphabet} key={index} />
                                        ))}
                                   </div>
                              </div>
                              {/* Title */}
                              <div className={style.myinfo_text_title}>
                                   <div className={style.myinfo_text_leftBox}>
                                        <div className={style.myinfo_text_key}>
                                             {"'Greeting':".split("").map((alphabet, index) => (
                                                  <Span alp={alphabet} key={index} />
                                             ))}
                                        </div>
                                   </div>

                                   <div className={style.myinfo_text_rightBox}>
                                        <div className={style.myinfo_text_value}>
                                             {"'Hi-My-Name-Is',".split("").map((alphabet, index) => (
                                                  <Span alp={alphabet} key={index} />
                                             ))}
                                        </div>
                                   </div>
                              </div>
                              {/* FullName */}
                              <div className={style.myinfo_text_name}>
                                   <div className={style.myinfo_text_leftBox}>
                                        <div className={style.myinfo_text_key}>
                                             {"'FullName':".split("").map((alphabet, index) => (
                                                  <Span alp={alphabet} key={index} />
                                             ))}
                                        </div>
                                   </div>

                                   <div className={style.myinfo_text_rightBox}>
                                        <p>
                                             {"'Richhapal-Choudhary',".split("").map((alphabet, index) => (
                                                  <Span alp={alphabet} key={index} />
                                             ))}
                                        </p>
                                   </div>
                              </div>
                              {/* Position */}
                              <div className={style.myinfo_text_position}>
                                   <div className={style.myinfo_text_leftBox}>
                                        <div className={style.myinfo_text_key}>
                                             {"'Domain':".split("").map((alphabet, index) => (
                                                  <Span alp={alphabet} key={index} />
                                             ))}
                                        </div>
                                   </div>

                                   <div className={style.myinfo_text_rightBox}>
                                        <p>
                                             {"'Full-Stack-Developer',".split("").map((alphabet, index) => (
                                                  <Span alp={alphabet} key={index} />
                                             ))}
                                        </p>
                                   </div>
                              </div>
                              {/* About */}
                              <div className={style.myinfo_text_about}>
                                   <div className={style.myinfo_text_leftBox}>
                                        <div className={style.myinfo_text_key}>
                                             {"'About':".split("").map((alphabet, index) => (
                                                  <Span alp={alphabet} key={index} />
                                             ))}
                                        </div>
                                   </div>

                                   <div className={style.myinfo_text_rightBox}>
                                        <div className={style.myinfo_text_value}>
                                             {"'A-Passionate-Full-Stack-Developer-From-India',".split("").map((alphabet, index) => (
                                                  <Span alp={alphabet} key={index} />
                                             ))}
                                        </div>
                                   </div>
                              </div>
                              {/* Experience */}
                              {/* Language */}
                              <div className={style.myinfo_text_language}>
                                   <div className={style.myinfo_text_leftBox}>
                                        <div className={style.myinfo_text_key}>
                                             {"'Language':".split("").map((alphabet, index) => (
                                                  <Span alp={alphabet} key={index} />
                                             ))}
                                        </div>
                                   </div>

                                   <div className={style.myinfo_text_rightBox}>
                                        <div className={style.myinfo_text_value}>
                                             {"['English','Hindi'],".split("").map((alphabet, index) => (
                                                  <Span alp={alphabet} key={index} />
                                             ))}
                                        </div>
                                   </div>
                              </div>
                              {/* Skills */}
                              <div className={style.myinfo_text_skill}>
                                   <div className={style.myinfo_text_leftBox}>
                                        <div className={style.myinfo_text_key}>
                                             {"'Skills':".split("").map((alphabet, index) => (
                                                  <Span alp={alphabet} key={index} />
                                             ))}
                                        </div>
                                   </div>

                                   <div className={style.myinfo_text_rightBox}>
                                        <div className={style.myinfo_text_value} id={style.skills} onClick={handleNavigate}>
                                             {"[...-Skill],".split("").map((alphabet, index) => (
                                                  <Span alp={alphabet} key={index} />
                                             ))}
                                        </div>
                                   </div>
                              </div>
                              {/* Resume */}
                                   {/*
                              <div className={style.myinfo_text_resume}>
                                   <div className={style.myinfo_text_leftBox}>
                                        <div className={style.myinfo_text_key}>
                                             {"'Resume':".split("").map((alphabet, index) => (
                                                  <Span alp={alphabet} key={index} />
                                             ))}
                                        </div>
                                   </div>

                                   <div className={style.myinfo_text_rightBox}>
                                        <div style={{ display: "inline-block" }} className={style.myinfo_text_value} onClick={openPDFInNewWindow}>
                                             {"'Resume.pdf',".split("").map((alphabet, index) => (
                                                  <Span alp={alphabet} key={index} />
                                             ))}
                                        </div>
                                   </div>
                              </div>
                              */}
                              {/* Profiles */}
                              <div className={style.myinfo_text_social}>
                                   <div className={style.myinfo_text_leftBox}>
                                        <div className={style.myinfo_text_key}>
                                             {"'Profiles':".split("").map((alphabet, index) => (
                                                  <Span alp={alphabet} key={index} />
                                             ))}
                                        </div>
                                   </div>

                                   <div className={style.myinfo_text_rightBox}>
                                        <div className={style.myinfo_text_value}>
                                             <Profiles />
                                        </div>
                                   </div>
                              </div>
                              {/* Social Connect with me */}
                              <div className={style.myinfo_text_social}>
                                   <div className={style.myinfo_text_leftBox}>
                                        <div className={style.myinfo_text_key}>
                                             {"'Connect-With-Me':".split("").map((alphabet, index) => (
                                                  <Span alp={alphabet} key={index} />
                                             ))}
                                        </div>
                                   </div>

                                   <div className={style.myinfo_text_rightBox}>
                                        <div className={style.myinfo_text_value}>
                                             <SocialConnect />
                                        </div>
                                   </div>
                              </div>

                              <div className={style.myinfo_text_object_declaration_curly}>
                                   {"}".split("").map((alphabet, index) => (
                                        <Span alp={alphabet} key={index} />
                                   ))}
                              </div>
                         </div>
                         {/* <div className={style.myinfo_image}>Image</div> */}
                    </div>
               </div>
          </section>
     );
};
export default Home;
